package com.essntl.features.service.data.supabase.supplierservice

import com.essntl.features.organization.data.supabase.OrganizationDto
import com.essntl.features.service.data.supabase.service.ServiceDto
import com.essntl.features.service.domain.model.supplierservice.SupplierServiceModel
import com.essntl.features.supplier.data.supabase.SupplierDto
import io.github.jan.supabase.postgrest.query.Columns
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SupplierServiceDto(
    val id: String,
    @SerialName("created_at")
    val createdAt: String,
    @SerialName("created_by")
    val createdBy: String?,
    @SerialName("service_id_data")
    val service: ServiceDto,
    @SerialName("supplier_id_data")
    val supplier: SupplierDto,
    @SerialName("organization_id_data")
    val organization: OrganizationDto,
) {
    fun toModel() =
        SupplierServiceModel(
            id = id,
            createdAt = createdAt,
            createdBy = createdBy,
            service = service.toModel(),
            supplier = supplier.toModel(),
            organization = organization.toModel(),
        )

    companion object {
        const val COLUMNS_VALUE =
            "*, service_id_data:service_id(${ServiceDto.COLUMNS_VALUE}), " +
                "supplier_id_data:supplier_id(${SupplierDto.COLUMNS_VALUE}), " +
                "organization_id_data:organization_id(${OrganizationDto.COLUMNS_VALUE})"

        fun getColumns() = Columns.raw(COLUMNS_VALUE)
    }
}